'use client';

import { Text } from '@backyard-ui/core';
import { useMediaQuery } from '@backyard-ui/hooks';
import { ChevronLeft, ChevronRight } from '@backyard-ui/icons';

import { styles } from './Breadcrumb.styles';

export interface BreadcrumbProps {
  items: {
    label: string;
    url?: string;
  }[];
}

const Breadcrumb = (props: BreadcrumbProps) => {
  const { items } = props;

  const isDesktop = useMediaQuery('lg');

  const classNames = styles();

  if (items.length === 0) {
    return null;
  }

  if (!isDesktop) {
    const previousPage = items[items.length - 2] ?? items[items.length - 1];

    return (
      <nav aria-label="breadcrumb" className={classNames.base()}>
        <a href={previousPage.url} className={classNames.backLink()}>
          <ChevronLeft className={classNames.backLinkChevron()} />
          <Text
            color="green-700"
            size="md"
            asChild
            UNSAFE_className={classNames.text()}
          >
            <span>{previousPage.label}</span>
          </Text>
        </a>
      </nav>
    );
  }

  const linkItems = items.slice(0, -1);
  const textItem = items[items.length - 1];

  return (
    <nav aria-label="breadcrumb" className={classNames.base()}>
      <ol className={classNames.list()}>
        {linkItems.map(({ url, label }) => (
          <li className={classNames.listItem()} key={url}>
            <Text
              color="green-700"
              size="md"
              asChild
              UNSAFE_className={classNames.text()}
            >
              <a href={url}>{label}</a>
            </Text>
            <ChevronRight className={classNames.listItemChevron()} />
          </li>
        ))}
        <li>
          <Text
            color="gray-600"
            size="md"
            asChild
            UNSAFE_className={classNames.text()}
          >
            <span>{textItem.label}</span>
          </Text>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
